import * as React from "react";
import * as style from "./shareButtons.module.scss";
import PropTypes from "prop-types";
import Link from "components/Link";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import BlueSkyIcon from "components/Icons/BlueSkyIcon/BlueSkyIcon";

const ShareButtons = ({ url, text, t }) => {
  return (
    <div className={style.ShareButtons}>
      <span className={style.ShareButtons_title}>
        {t("shareButtons.title")}
      </span>
      <div className={style.ShareButtons_links}>
        <Link to={`https://bsky.app/intent/compose?text=${encodeURIComponent(text)} ${url} @citius.gal`}>
          <BlueSkyIcon />
        </Link>
        <Link to={`https://www.facebook.com/sharer/sharer.php?u=${url}`}>
          <FacebookIcon />
        </Link>
        <Link to={`https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(text)} ${url}`}>
          <LinkedInIcon />
        </Link>
      </div>
    </div>
  );
};

export default ShareButtons;

ShareButtons.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  t: PropTypes.func,
};

ShareButtons.displayName = "ShareButtons";
